import { createSelector } from 'reselect';
import { initialState as initRootState } from '@vfde-fe/sails_core';
import { initialState } from './reducer';
import NAMESPACE from './constant';

const selectRootDomain = state => state.app || initRootState;
const selectOverlayState = (state) => state[NAMESPACE] || initialState;

const selectRootOverlayState = () =>
    createSelector(
        selectRootDomain,
        state => state.overlay,
    );
const selectRootOverlayNameState = () =>
    createSelector(
        selectRootDomain,
        state => state.overlayName,
    );
const selectOverlayLoaded = () =>
    createSelector(
        selectOverlayState,
        state => state.overlayLoaded,
    );

export {
    selectRootDomain,
    selectRootOverlayState,
    selectRootOverlayNameState,
    selectOverlayLoaded,
};
